const C = {
  yellow: '#F7DA8A',
  amber: '#E2A763',
  cream: '#FBF2D3',
  salmon: '#F9A59A',
  dark: '#521616',
  mono: '"IBM Plex Mono", monospace',
};

export const styles = {
  personBtnCont: {
    position: 'relative' as const,
    animation: 'float 3s infinite ease-in-out',
    zIndex: 1000,
  },
  personButton: {
    background: C.amber,
    border: `1px solid ${C.dark}`,
    borderRadius: '93px',
    boxShadow: 'inset -3px -3px 0px rgba(212, 28, 28, 0.25)',
    color: C.dark,
    fontFamily: C.mono,
    fontSize: '14px',
    fontWeight: 400,
    padding: '8px 18px',
    whiteSpace: 'nowrap' as const,
    cursor: 'pointer' as const,
    pointerEvents: 'auto' as const,
    userSelect: 'none' as const,
    position: 'relative' as const,
    transition: 'all 0.3s ease',
    overflow: 'hidden',
    minWidth: '140px',
    textAlign: 'left' as const,
  },
  personButtonLocked: {
    background: C.cream,
    opacity: 0.7,
    cursor: 'not-allowed' as const,
    pointerEvents: 'none' as const,
    userSelect: 'none' as const,
    display: 'flex' as const,
    alignItems: 'center' as const,
    gap: '6px',
  },
  personButtonShine: {
    position: 'absolute' as const,
    top: 0,
    left: '-100%',
    width: '100%',
    height: '100%',
    background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent)',
    animation: 'shine 2s infinite',
  },
  lockedIcon: {
    background: 'rgba(82, 22, 22, 0.1)',
    borderRadius: '50%',
    width: '18px',
    height: '18px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '12px',
  },
  compleatedContainer: {
    background: C.cream,
    border: `1px solid ${C.dark}`,
    borderRadius: '93px',
    boxShadow: 'inset -3px -3px 0px rgba(212, 28, 28, 0.25)',
    color: C.dark,
    fontFamily: C.mono,
    padding: '2px 10px',
    fontSize: '10px',
    whiteSpace: 'nowrap' as const,
    userSelect: 'none' as const,
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    position: 'absolute' as const,
    top: 0,
    left: '10px',
    overflow: 'hidden',
    transform: 'translateY(-50%)',
  },
  completedIcon: {
    background: 'rgba(82, 22, 22, 0.15)',
    borderRadius: '50%',
    width: '10px',
    height: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
};

